module.exports = __webpack_public_path__ + "img/lit_faq.f00b48b3.png";